module.exports = __webpack_public_path__ + "media/images/front/icons/copy_icon-4cf895133b09857097b1e08910b925f8.png";